module.exports = __webpack_public_path__ + "img/dizhi.a242cf49.png";